import { render, staticRenderFns } from "./bimManage.vue?vue&type=template&id=39121b96&scoped=true"
import script from "./bimManage.vue?vue&type=script&lang=js"
export * from "./bimManage.vue?vue&type=script&lang=js"
import style0 from "./bimManage.vue?vue&type=style&index=0&id=39121b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39121b96",
  null
  
)

export default component.exports